enum DialogWindowType {
  CONFIRM = "confirm",
  LICENSE = "license",
  CONTACTFORM = "contact-form",
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export default DialogWindowType;
